import _ from 'lodash'
import env from '@/env.js'

const regex = {
  weixin: /^([a-zA-Z][\w-]{5,19}|[1-9]\d{4,19})$/
}

export default {
  pathToUserId (path = '') {
    let pre3 = path.substring(0, 3)
    if (pre3 !== '/p/' && pre3 !== '/u/') {
      return null
    }
    let match = path.substring(3).match(/^([a-z0-9-]+)/)
    return match ? match[0] : match
  },
  isWeixin (weixin) {
    if (!_.isString(weixin)) {
      return false
    }
    return regex.weixin.test(weixin)
  },
  imgCdnSuffix () {
    let suffix = 'basic='
    if (env.isChrome) {
      suffix += '.webp'
    }
    return suffix
  }
}



// WEBPACK FOOTER //
// ./src/util.js